var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_vm.currentMessage,{tag:"component",attrs:{"message":_vm.message,"project":_vm.project}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }